import { normalizeContentLocale } from '@ai-content-hub/content-core';
import type { I18nConfig } from '@ai-content-hub/content-core';
import type { ElementRuntimeConfigSlice } from '@ai-content-hub/content-kit';

/**
 * Read `config.i18n` from element editor/player props into a strict {@link I18nConfig}.
 */
export function parentI18nFromElementConfig(
    config?: ElementRuntimeConfigSlice
): I18nConfig | undefined {
    if (!config?.i18n || typeof config.i18n !== 'object') {
        return undefined;
    }
    const raw = config.i18n as {
        defaultLanguage?: string;
        languages?: Record<string, Record<string, string>>;
    };
    const languages =
        raw.languages && typeof raw.languages === 'object' ? raw.languages : {};
    const hasDefault =
        raw.defaultLanguage !== undefined &&
        raw.defaultLanguage !== null &&
        String(raw.defaultLanguage).trim() !== '';
    const hasLanguageStrings = Object.keys(languages).length > 0;
    if (!hasDefault && !hasLanguageStrings) {
        return undefined;
    }
    return {
        defaultLanguage: normalizeContentLocale(hasDefault ? String(raw.defaultLanguage) : undefined),
        languages,
    };
}
